var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-content"},[_vm._m(0),_c('div',{staticClass:"text"},[_c('span',{staticClass:"iconfont icon-sad"},[_vm._v("")]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.L.noData))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/no_content.png")}})])
}]

export { render, staticRenderFns }